export enum TriggerEventName {
    USER_SIGNUP = 'user_signup',
    USER_LOGIN = 'user_login',
    USER_LOGOUT = 'user_logout',
    PAGE_VIEW = 'page_view',
    CART_ADD = 'cart_add',
    CART_REMOVE = 'cart_remove',
    WISHLIST_ADD = 'wishlist_add',
    WISHLIST_REMOVE = 'wishlist_remove',
    SEARCH = 'search',
    PASSWORD_CHANGE = 'password_change',
    EMAIL_SUBSCRIBE = 'email_subscribe',
    EMAIL_UNSUBSCRIBE = 'email_unsubscribe',
    LOCATION_UPDATE = 'location_update',
    MODEL_VIEW = 'model_view',
    CATALOG_VIEW = 'catalog_view',
    CUSTOM_EVENT = 'custom_event'
}

export default interface TriggerEventInterface {
    id?: number;
    event_name: TriggerEventName;
    event_value: string | null;
    customer_identity_type: string | null;
    customer_identity_value: any | null;
    uid: string;
    created_at?: string; // ISO date string
}